<template>
  <div class="content">
    <agregar-usuario @update="update"></agregar-usuario>
    <eliminar-usuario @update="update"></eliminar-usuario>
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">ABM Usuarios</h4>

                    <p class="card-category">Alta, baja y modificación</p>
                  </div>

                  <div>
                    <button
                      @click="$bvModal.show('addUser')"
                      class="btn btn-success"
                    >
                      <i class="fas fa-user-plus"></i>
                      Agregar usuario
                    </button>
                  </div>
                </div>
              </template>
              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="label" for="quickFilter">
                        Filtro rapido
                      </label>

                      <input
                        id="quickFilter"
                        v-model="quickFilter"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="container-fluid h-100">
                  <div class="row" style="height: 100%">
                    <div class="col" style="position: relative; height: 100%">
                      <ag-grid-vue
                        style="width: 100%; height: 60vh"
                        class="ag-theme-alpine"
                        :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef"
                        :rowData="usuariosData"
                        @grid-ready="onGridReady"
                        :gridOptions="gridOptions"
                        :getContextMenuItems="getContextMenuItems"
                      >
                      </ag-grid-vue>
                    </div>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgregarUsuario from "./AgregarUsuario";
import EliminarUsuario from "./EliminarUsuario";
import UsuariosTableActions from "./UsuariosTableActions";
import axios from "axios";

import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import { get } from "lodash-es";

export default {
  name: "UsersList",
  components: {
    AgregarUsuario,
    EliminarUsuario,
    // eslint-disable-next-line
    UsuariosTableActions,
    AgGridVue,
  },
  beforeMount() {
    this.defaultColDef = {
      sortable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };

    this.gridOptions = {
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    };
  },
  data: () => ({
    quickFilter: "",

    // ag-grid config
    modules: AllModules,

    gridOptions: null,
    gridApi: null,

    defaultColDef: null,
    usuariosData: [],
    columnDefs: [
      {
        headerName: "#",
        field: "id_usuario",
        flex: 1,
        sort: "asc",
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
      },
      { headerName: "Nombre de usuario", field: "nom_usuario", flex: 2 },
      { headerName: "Nombre", field: "nombre", flex: 2 },
      { headerName: "Apellido", field: "apellido", flex: 2 },
      { headerName: "DNI", field: "DNI", flex: 2 },
      {
        headerName: "Acciones",
        cellRendererFramework: UsuariosTableActions,
        flex: 3,
      },
    ],
  }),

  methods: {
    async update() {
      this.getData();
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    async getData() {
      this.gridApi.showLoadingOverlay();
      const resp = await axios.post("/execute", {
        method: "SEC.GetUsuarios",
        parameters: [],
      });
      if (resp.data.ok) {
        this.usuariosData = get(resp, "data.result[0]", []);
        this.gridApi.hideOverlay();
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
    onGridReady(params) {
      // Agrega el filtro rápido al inicializar la tabla
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getData();
    },
  },
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>

<style></style>
